import { Sentry } from "@somewear/model";
import { setGlobalError, setUpgrade } from "@web/app/appSlice";
import GlobalErrorComponent from "@web/components/GlobalErrorComponent";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRouteError } from "react-router-dom";

// Vite emits dynamic-import failures as TypeErrors with these messages;
// "ChunkLoadError" covers any webpack-style environments.
const CHUNK_ERROR_PATTERN =
	/Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

/**
 * Root errorElement: render + route-lazy chunk errors land here.
 */
const RootErrorBoundary: React.FunctionComponent = () => {
	const error = useRouteError();
	const dispatch = useDispatch();

	useEffect(() => {
		const isChunkError =
			error instanceof Error &&
			(error.name === "ChunkLoadError" || CHUNK_ERROR_PATTERN.test(error.message));
		if (isChunkError) {
			dispatch(setUpgrade(true));
		} else {
			Sentry.captureException(error);
		}
		dispatch(setGlobalError());
	}, [dispatch, error]);

	return <GlobalErrorComponent />;
};

export default RootErrorBoundary;
